import { Card, CardContent } from "@/components/ui/card";
import { INVOICE_TYPES, STANDARD_TYPES, fmtEUR } from "./shared";

function Kpi({ label, value, sub, testid, accent }) {
  return (
    <Card data-testid={testid}>
      <CardContent className="p-4">
        <div className="text-[10px] uppercase tracking-[0.15em] text-muted-foreground">{label}</div>
        <div className={`font-heading text-2xl font-bold mt-1 ${accent || ""}`}>{value}</div>
        {sub && <div className="text-xs text-muted-foreground mt-0.5">{sub}</div>}
      </CardContent>
    </Card>
  );
}

export function InvoiceKpis({ projects }) {
  const all = projects.flatMap((p) => p.rechnungen || []);
  const sum = (list) => list.reduce((s, r) => s + (Number(r.betrag) || 0), 0);
  const bezahlt = all.filter((r) => r.status === "bezahlt");
  const ausstehend = all.filter((r) => ["erstellt", "versendet"].includes(r.status));
  const perType = STANDARD_TYPES.map((t) => {
    const list = all.filter((r) => r.typ === t);
    const offen = list.filter((r) => r.status === "offen").length;
    const gestellt = list.filter((r) => r.status !== "offen");
    return { t, offen, gestellt: gestellt.length, betrag: sum(gestellt) };
  });

  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-3" data-testid="invoice-kpis">
      {perType.map(({ t, offen, gestellt, betrag }) => (
        <Kpi key={t} testid={`kpi-${t}`} label={INVOICE_TYPES[t]} value={`${gestellt} gestellt`}
          sub={`${offen} noch offen · ${fmtEUR(betrag)}`} />
      ))}
      <Kpi testid="kpi-ausstehend" label="Zahlung ausstehend" value={fmtEUR(sum(ausstehend))}
        sub={`${ausstehend.length} Rechnungen`} accent="text-amber-600 dark:text-amber-400" />
      <Kpi testid="kpi-bezahlt" label="Bezahlt" value={fmtEUR(sum(bezahlt))}
        sub={`${bezahlt.length} Rechnungen`} accent="text-emerald-600 dark:text-emerald-400" />
    </div>
  );
}
